/**
 * Sample consultations for the admin list PREVIEW/QA only (never production).
 * Generated relative to "now" so the list always has upcoming rows.
 */
import type { AdminConsultation } from '../lib/consultAdminStore';

function at(dayOffset: number, hh: number, mm: number): { s: string; e: string } {
  const s = new Date();
  s.setDate(s.getDate() + dayOffset);
  s.setHours(hh, mm, 0, 0);
  const e = new Date(s.getTime() + 30 * 60_000);
  return { s: s.toISOString(), e: e.toISOString() };
}

export function sampleConsultations(): AdminConsultation[] {
  const a = at(1, 11, 0);
  const b = at(2, 18, 30);
  const c = at(3, 8, 30);
  const d = at(-1, 15, 0);
  return [
    {
      id: 'CS-SAMPLE-0001',
      clientName: 'Sumit Verma',
      email: 'sumit@example.com',
      phone: '+91 98765 43210',
      startISO: a.s,
      endISO: a.e,
      timeZone: 'Asia/Kolkata',
      clientTz: 'Asia/Kolkata',
      status: 'confirmed',
      source: 'door_b_selfserve',
      meetUrl: 'https://meet.google.com/aayatan-preview',
      typeName: 'Discovery / Consultation Call',
      rescheduledToId: null,
    },
    {
      id: 'CS-SAMPLE-0002',
      clientName: 'Aisha Rahman',
      email: 'aisha@example.com',
      phone: '+971 50 123 4567',
      startISO: b.s,
      endISO: b.e,
      timeZone: 'Asia/Kolkata',
      clientTz: 'Asia/Dubai',
      status: 'confirmed',
      source: 'door_a_staff',
      meetUrl: 'https://meet.google.com/aayatan-preview',
      typeName: 'Discovery / Consultation Call',
      rescheduledToId: null,
    },
    {
      id: 'CS-SAMPLE-0003',
      clientName: 'David Cohen',
      email: 'david@example.com',
      phone: '+1 415 555 0134',
      startISO: c.s,
      endISO: c.e,
      timeZone: 'Asia/Kolkata',
      clientTz: 'America/New_York',
      status: 'pending',
      source: 'door_b_selfserve',
      meetUrl: null,
      typeName: 'Discovery / Consultation Call',
      rescheduledToId: null,
    },
    {
      id: 'CS-SAMPLE-0004',
      clientName: 'Priya Nair',
      email: 'priya@example.com',
      phone: '+91 90000 11111',
      startISO: d.s,
      endISO: d.e,
      timeZone: 'Asia/Kolkata',
      clientTz: 'Asia/Kolkata',
      status: 'cancelled',
      source: 'door_b_selfserve',
      meetUrl: null,
      typeName: 'Discovery / Consultation Call',
      rescheduledToId: null,
    },
  ];
}
